import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  width: 100%;
`;

const SelectBox = styled.div`
  border: 2px solid #B0BEC5;
  border-radius: 10px;
  padding: 14px 16px;
  color: #1565C0;
  font-size: 15px;
  background-color: #F7F9FC;
  cursor: pointer;
  user-select: none;
  transition: border-color 0.3s, box-shadow 0.3s, background-color 0.3s;

  &:hover {
    border-color: #90A4AE;
    background-color: #ECEFF1;
  }

  &:focus-within {
    border-color: #1565C0;
    box-shadow: 0 0 6px rgba(21, 101, 192, 0.4);
    outline: none;
  }
`;

const DropdownList = styled.ul`
  list-style: none;
  margin: 5px 0 0 0;
  padding: 0;
  border: 2px solid #B0BEC5;
  border-radius: 10px;
  background-color: #F7F9FC;
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  z-index: 1000;
  max-height: 180px;
  overflow-y: auto;
  box-shadow: 0 3px 6px rgba(0,0,0,0.1);
`;

const DropdownItem = styled.li`
  padding: 10px 14px;
  color: #1565C0;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
  border-radius: 8px;
  margin: 4px;

  &:hover {
    background-color: #ECEFF1;
  }

  &:active {
    background-color: #DCE3E7;
  }
`;

const SelectRegion = ({ setType, regions, regionL }) => {  
  const [selected, setSelected] = useState('');
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (reg) => {
    if(reg.region_id === 0){
        setSelected(null);
        setType(null);
    }else{
        setSelected(reg.region_name);
        setType?.(reg.region_id);
    }
    setOpen(false);
  };

  useEffect(() => {
    setSelected(regionL || '');
  }, [regionL]);

  return (
    <Container ref={containerRef}>
      <SelectBox onClick={() => setOpen((prev) => !prev)} tabIndex="0">
        {selected || 'Select region'}
      </SelectBox>
      {open && (
        <DropdownList>
          {[{region_id: 0, region_name: "Select region"}, ...regions]?.map((region) => (
            <DropdownItem
              key={region.region_id}
              onClick={() => handleSelect(region)}
            >
              {region.region_name}
            </DropdownItem>
          ))}
        </DropdownList>
      )}
    </Container>
  );
};

export default SelectRegion;
